import React from 'react';
import PropTypes from 'prop-types';
import { HighlightedAttribute } from 'wsm-highlighted-attribute';
import { ErrorBoundary } from 'wsm-error-boundary';

/**
 * Factory component for creating highlighted attributes
 * Wraps attributes in error boundary and handles rendering logic
 */
export const HighlightedAttributeFactory = ({
	type,
	content,
	badgeClasses = [],
	chipColorStyle
}) => {
	if (type === 'vehicleViews') {
		return content;
	}

	return (
		<ErrorBoundary newRelicPageAction="ws-vehicle-title HighlightedAttribute error boundary">
			<HighlightedAttribute
				type={type}
				badgeClasses={badgeClasses}
				chipColorStyle={chipColorStyle}
			>
				{content}
			</HighlightedAttribute>
		</ErrorBoundary>
	);
};

HighlightedAttributeFactory.propTypes = {
	type: PropTypes.string,
	content: PropTypes.node.isRequired,
	badgeClasses: PropTypes.arrayOf(PropTypes.string),
	chipColorStyle: PropTypes.string
};

HighlightedAttributeFactory.defaultProps = {
	type: '',
	badgeClasses: [],
	chipColorStyle: 'Colored'
};
